import { useEffect } from 'react';

const useSlotClickEvent = (name: string, callback?: () => void, earlyReturn?: boolean) => {
  useEffect(() => {
    if (earlyReturn) {
      return () => {};
    }

    const onCallback = () => {
      callback!();
    };

    document.addEventListener(name, onCallback);
    return () => document.removeEventListener(name, onCallback);
  }, [earlyReturn]);
};
export default useSlotClickEvent;
